import React, { useEffect, useState } from "react";
import { Modal, Button, Table, Spinner } from "react-bootstrap";
import { useTranslate } from "../../hooks/LanguageProvider";

const backendUrl = process.env.REACT_APP_BACKEND_URL;


interface ModalViewProgramsProps {
  show: boolean;
  onHide: () => void;
  id_site: number;
  selectedSiteName?: string | null;
}

const ModalViewPrograms: React.FC<ModalViewProgramsProps> = ({ show, onHide, id_site,selectedSiteName }) => {
  const { translate } = useTranslate();
  const [programs, setPrograms] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);
const id_user = localStorage.getItem("userid");
const isAdmin = id_user === "1";
const fetchProgramsBySite = async () => {
  try {
    setLoading(true);

    const res = await fetch(`${backendUrl}/api/program/search`, {
      method: "POST",
      credentials: "include",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        limitValue: 999,          // large enough to get all rows
        currentPage: 1,
        id_user: localStorage.getItem("userid") || localStorage.getItem("userid"),
        search: "",               // no search filter
        type: 0,                  // default type
        column: "id_program",     // optional ordering
        sort: "DESC",
        id_site, 
      }),
    });

    if (!res.ok) throw new Error("Failed to fetch programs");

    const data = await res.json();
    setPrograms(data);            // same state you use to render the table
  } catch (err) {
    console.error("Error fetching programs by site:", err);
    setPrograms([]);
  } finally {
    setLoading(false);
  }
};


useEffect(() => {
  if (show && id_site) {
    fetchProgramsBySite();
  }
}, [show, id_site]);

//console.log("User ID:", id_user, "isAdmin:", isAdmin);

  return (
    <Modal show={show} onHide={onHide} size="xl" centered>
      <Modal.Header closeButton>
        <Modal.Title> {translate("Programs for site:")} <strong>{selectedSiteName || "N/A"}</strong></Modal.Title>
      </Modal.Header>

      <Modal.Body>
        {loading ? (
          <div className="d-flex justify-content-center align-items-center" style={{ height: "200px" }}>
            <Spinner animation="border" />
          </div>
        ) : programs.length > 0 ? (
          <Table striped bordered hover responsive>
            <thead>
              <tr>
                {isAdmin && <th>ID</th>}
                <th>{translate("Date")}</th>
                <th>{translate("Departure")}</th>
                <th>{translate("Destination")}</th>
                <th>{translate("Type")}</th>
                <th>{translate("Driver")}</th>
                <th>{translate("Vehicle")}</th>
                <th>{translate("Observation")}</th>
                <th>{translate("Status")}</th>
              </tr>
            </thead>
            <tbody>
              {programs.map((p) => (
                <tr key={p.id_program}>
                  {isAdmin && <td>{p.id_program}</td>}
                  <td>{new Date(p.program_date).toLocaleDateString()}</td>
                  <td>{p.departure}</td>
                  <td>{p.destination}</td>
                  <td>{p.type}</td>
                  <td>{p.nom_conducteur}</td>
                  <td>{p.immatriculation_vehicule}</td>
                  <td>{p.observation}</td>
                  <td>{p.status}</td>
                </tr>
              ))}
            </tbody>
          </Table>
        ) : (
          <p className="text-center text-muted">{translate("No programs found for this site")}</p>
        )}
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          {translate("Close")}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ModalViewPrograms;
